import React from 'react';

import { IImageWith5050TextFields } from '../../../types/contentful';

import { getImageData } from '../../utils/contentful';

import { Text } from '../Text';
import { Box } from '../Box';
import RichText from '../RichText';
import { BlockContainer, Layout, Column } from '../Layout';

import {
  ImageWrapper,
  TextWrapper,
  ColumnContainer,
  StyledImage
} from './styles';

interface Props extends IImageWith5050TextFields {
  sysId?: string;
}

export function ImageWith5050Text({
  headingText,
  image,
  bodyCopy,
  imageFirst,
  sysId
}: Props) {
  return (
    <BlockContainer
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-elementtype="imageWith5050Text"
      data-elementid={sysId}
      data-testid="imageWith5050Text"
    >
      <Layout
        gutter={{ 0: 'ml', desktop: 'xl' }}
        flexWrap="wrap"
        alignItems="center"
        flexDirection={{
          0: 'column',
          tablet: imageFirst ? 'row' : 'row-reverse'
        }}
      >
        <Column size={{ 0: 12, tablet: 6, desktop: 6 }}>
          <ImageWrapper id="image-wrapper">
            <StyledImage
              {...getImageData(image)}
              loading="eager"
              data-blockid="imageWith5050Text-image"
            />
          </ImageWrapper>
        </Column>
        <ColumnContainer size={{ 0: 10, tablet: 6, desktop: 4 }}>
          <TextWrapper>
            <Box marginBottom={{ 0: 'sm' }}>
              <Text
                as="h2"
                fontWeight={{ 0: 'h2' }}
                fontSize={{ 0: 'h2_0', desktop: 'h2_desktop' }}
                data-blockid="imageWith5050Text-headline"
              >
                {headingText}
              </Text>
            </Box>
            {bodyCopy && (
              <Box
                marginBottom={{ 0: 'ml' }}
                data-blockid="imageWith5050Text-subhead"
              >
                <RichText data={bodyCopy} />
              </Box>
            )}
          </TextWrapper>
        </ColumnContainer>
      </Layout>
    </BlockContainer>
  );
}
